<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <button nz-popconfirm nzPopconfirmTitle="Are you sure delete this task?" nzPopconfirmPlacement="bottom"
    (nzOnConfirm)="confirm()" (nzOnCancel)="cancel()" nzPopconfirmPlacement="top" nz-button
    nzType="primary">Delete</button>
</div>